import { request } from '@/shared/api/request'
export const sspDataForPerson = (bin, iin) =>
	request({
		url: '/contract/universalMethods/sspDataForPerson?bin=' + bin + '&iin=' + iin,
		method: 'GET',
	})
